import { generateID } from "@digitallab/grid-common-frontend-components";
import { OwcTextarea } from "@one/react";
import { Module } from "../../../../constants";
import COMMON_LOGS_DATA_MODEL from "../../../../utils/constants/commonLogsDataModel";
import { FormikProps } from "formik";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";

export const DescriptionTestArea = ({ formik }: { formik: FormikProps<{ [name: string]: string }> }) => (
  <OwcTextarea
    data-testid="action-data-inputs-description-input"
    id={generateID.textBoxID(Module.POPUP_FIELDS.actionDescription, "textbox")}
    label={COMMON_LOGS_DATA_MODEL.description.value + ` *`}
    onInputChange={(event) => {
      formik.setFieldValue("description", event.detail ?? "", true);
    }}
    onInputKeyDown={(event) => {
      formik.setFieldValue("description", event.detail ?? "", true);
    }}
    onInputReset={() => formik.setFieldValue("description", "", true)}
    value={formik.values.description}
    required
    resizable
    reset
    rows={4}
    cols={20}
    maxLength={1000}
    minLength={0}
    {...react18WorkaroundProps}
    placeholder="Enter description"
  />
);
